(function() {

    if( window.location.pathname === '/account/login' ){

        var hash = window.location.hash,
            toggleSections = function( hash ) {

                if( hash === '#recover' ) {

                    if( $( '.form-alert' ).length === 0 ) {

						$( '#forgot-password' ).removeClass( 'hidden' );

                    } else {

                        setTimeout( function() {

                            $( '.form-alert' ).removeClass( 'error' );

						}, 5000 );

                    }

                }

            };

		toggleSections( hash );

       $( '.js-recover-form' ).validate({
			onfocusout: false,
			invalidHandler: function( form, validator ) {

				var errors = validator.numberOfInvalids();
				if ( errors ) {

					validator.errorList[ 0 ].element.focus();

				}
			}
		});

       $( '#forgot-password-trigger' ).on( 'click', function(e) {

            if( $( '.js-recover-form' ).valid() ) {

                $( '.js-recover-form' ).submit();

            }

		});

		if( $( '.js-form-error' ).length > 0 ) {

			setTimeout( function() {

				$( '.js-form-error' ).focus();

			}, 500 );
		}

    }

})();
